import queryString from "query-string";
import type { Policy } from "~/application/types";
import { api } from "~/infrastructure/api";
import type { PolicyDTO } from "~/infrastructure/api/dtos";
import type { FormPolicyData, IPolicyService } from "./IPolicyService";
import { mapPolicyDTO } from "~/infrastructure/api/mappers";
import { FormDataBuilder } from "~/application/utils/object-functions";

export class PolicyService implements IPolicyService {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async findById(id: string): Promise<Policy> {
    throw new Error("Method not implemented.");
  }

  async find({
    customerId,
    isExpensePolicy,
  }: {
    customerId: string;
    isExpensePolicy?: boolean;
  }): Promise<Policy[]> {
    const url = queryString.stringifyUrl(
      {
        url: `/customers/${customerId}/policies`,
        query: {
          product_type: isExpensePolicy ? "expense" : undefined,
        },
      },
      {
        skipNull: true,
      },
    );

    return await api.get<PolicyDTO[]>(url).then(({ data }) => data.map(mapPolicyDTO));
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async create(data: Omit<Policy, "uuid">): Promise<Policy> {
    throw new Error("Method not implemented.");
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async update(data: FormPolicyData): Promise<void> {
    const formData = {
      value: data.value,
    };
    await api.put(`/customers/policy-values/${data.policyValueId}`, formData);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async toggleActive(data: Policy): Promise<void> {
    throw new Error("Method not implemented.");
  }

  async uploadJustificationAttachment(data: File): Promise<string> {
    const builder = new FormDataBuilder({ file: data });
    const formData = builder.getFormData();
    const { data: response } = await api.post<{ url: string }>(
      "/justification-attachment",
      formData,
    );
    return response.url;
  }
}
